import React from 'react';

function Works2() {
  return (
    <div className="section-padding pt-0">
      <div className="container">
        <div className="img">
          <img src="/dark/assets/imgs/works/projects/1/4.jpg" alt="" />
        </div>
        <div className="img-column-sm mt-30">
          <div className="row">
            <div className="col-lg-6">
              <div className="img md-mb30">
                <img src="/dark/assets/imgs/works/projects/1/5.jpg" alt="" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="img">
                <img src="/dark/assets/imgs/works/projects/1/6.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Works2;
